import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  computed,
  input,
  signal,
} from '@angular/core';

import { ButtonModule } from 'primeng/button';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';

@Component({
  selector: 'app-file-drop-zone',
  standalone: true,
  imports: [CommonModule, FileUploadModule, ButtonModule],
  templateUrl: './file-drop-zone.component.html',
  styleUrls: ['./file-drop-zone.component.scss'],
})
export class FileDropZoneComponent {
  @ViewChild('fileUpload') fileUpload?: FileUpload;

  readonly name = input<string>('file-drop-zone');
  readonly accept = input<string>('.pdf,.docx');
  readonly maxFileSize = input<number>(10 * 1024 * 1024);
  readonly multiple = input<boolean>(false);
  readonly isUploading = input<boolean>(false);
  readonly disabled = input<boolean>(false);
  readonly label = input<string>('Seleziona File');
  readonly labelId = input<string>('file-drop-zone-label');
  readonly helpText = input<string | null>(null);
  readonly emptyStateTitle = input<string>('Trascina qui il file');
  readonly emptyStateSubtitle = input<string>('oppure');
  readonly chooseLabel = input<string>('Scegli File');
  readonly replaceLabel = input<string>('Scegli un altro file');
  readonly uploadingLabel = input<string>('Caricamento in corso...');

  @Output() readonly filesSelected = new EventEmitter<File[]>();
  @Output() readonly fileRemoved = new EventEmitter<File>();
  @Output() readonly filesCleared = new EventEmitter<void>();
  @Output() readonly invalidFileSize = new EventEmitter<File>();
  @Output() readonly invalidFileType = new EventEmitter<File>();

  readonly selectedFiles = signal<File[]>([]);
  readonly hasFiles = computed(() => this.selectedFiles().length > 0);

  onSelect(event: { currentFiles: File[]; files: File[] }): void {
    const files = event.currentFiles ?? event.files ?? [];
    this.selectedFiles.set(files);
    this.filesSelected.emit(files);
  }

  onRemove(event: { file: File }): void {
    const removed = event.file;
    this.selectedFiles.update((prev) => prev.filter((f) => f !== removed));
    this.fileRemoved.emit(removed);
  }

  onClear(): void {
    this.selectedFiles.set([]);
    this.filesCleared.emit();
  }

  onFileSizeError(event: unknown): void {
    const file = (event as { files?: File[] }).files?.[0];
    if (file) this.invalidFileSize.emit(file);
  }

  onFileTypeError(event: unknown): void {
    const file = (event as { files?: File[] }).files?.[0];
    if (file) this.invalidFileType.emit(file);
  }

  /** Reset esterno (dopo submit o annullamento). */
  reset(): void {
    this.fileUpload?.clear();
    this.selectedFiles.set([]);
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 B';
    const units = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${units[i]}`;
  }
}
